define('home/views/ModeratedForumsModuleItemView',[
    'backbone-marionette',

    'home/templates/moderatedForumsModuleItem',
], function (
    Marionette,

    moderatedForumsModuleItemTemplate
) {
    'use strict';

    /**
     * Shows a single forum in a module.
     *
     * Expects a Forum model.
     */
    var ModeratedForumsModuleItemView = Marionette.ItemView.extend({
        template: moderatedForumsModuleItemTemplate,
        initialize: function () {
            if (this.model.shouldFetch())
                this.model.fetch();

            this.listenTo(this.model, 'sync', this.render);
        },
    });

    return ModeratedForumsModuleItemView;
});

